import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { OutlineButton } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const PaymentMethodSummaryButton = styled(OutlineButton)`
  font-size: ${themeGet('fontSizes.sm')};
  padding: ${themeGet('space.1')};
  width: 140px;
  letter-spacing: 1px;
  ${mediaQuery.minWidth.sm} {
    font-size: ${themeGet('fontSizes.sm')};
  }
`;
